export function wait(milliseconds: number) {
  return new Promise((resolve) => {
    const wait = setTimeout(() => {
      clearTimeout(wait);
      resolve(true);
    }, milliseconds);
  });
}
